import React from 'react'
import Hero from './Hero'
import BandResult from './BandResult'
import OneOnOneClass from './OneOnOneClass'
import SuccessGuarantee from './SuccessGuarantee'
import WorldClassContent from './WorldClassContent'
import ChooseYourProgram from './ChooseYourProgram'
import PersonalTeacher from './PersonalTeacher'
import TryDemoClass from './TryDemoClass'
import AceYourIelts from './AceYourIelts'
import OurStudent from './OurStudent'

const Mainpage = () => {
  return (
    <>
      <Hero />
      <BandResult />
      <OneOnOneClass/>
      <SuccessGuarantee/>
      <WorldClassContent/>
      <ChooseYourProgram/>
      <PersonalTeacher/>
      <TryDemoClass/>
      <OurStudent/>
      <AceYourIelts/>
    </>
  )
}

export default Mainpage